import axios from "axios";
import * as qs from "querystring";
import * as toastr from "toastr";

import ENDPOINT_CONFIG from "Placements/Configs/Endpoints.config";
import getBaseURL from "Placements/Utils/GetBaseURL.util";

const _ENDPOINT: any = ENDPOINT_CONFIG;
const Request: any = axios.create({ baseURL: getBaseURL() + "/PlacementsServer" });

const getURLPath = (url: string, parameters: Array<object>) =>
    parameters && parameters.length > 0
        ? parameters
            .filter((parameter: any) => parameter.in == "path")
            .reduce(
                (url: string, parameter: any) =>
                    url.replace(`:${parameter.name}`, parameter.value),
                url
            )
        : url;

const getURLQuery = (url: string, parameters: Array<object>) => {
    const newParameters =
        parameters &&
        parameters.filter(
            (parameter: any) =>
                parameter.in == "query" && parameter.value !== undefined
        );

    if (newParameters && newParameters.length > 0) {
        const values = newParameters.reduce(
            (values: any, { name, value, type }: any) => {
                if (name) {
                    values[name] = value;
                    values[name] = values[name] !== "{}" ? values[name] : "";
                } else if (type === "json") return value;
                return values;
            },
            {}
        );
        return `${url}?${qs.stringify(values, null, null, null)}`;
    } else return url;
};

const getURL = (url: string, parameters: Array<object>) => {
    return getURLQuery(getURLPath(url, parameters), parameters);
};

const getParametersWithData = (parameters: Array<any>, data: any) => {
    return (
        parameters &&
        parameters.reduce((acc, parameter: any) => {
            let newParamenter = { ...parameter };
            if (data[parameter.name] !== undefined)
                newParamenter = {
                    ...newParamenter,
                    value: data[parameter.name],
                };

            if (parameter.type === "json")
                newParamenter = { ...newParamenter, value: data };

            return [...acc, newParamenter];
        }, [])
    );
};

const processError = ({ service, summary }: any) => (error: any) => {
    const { response } = error;

    if (response && response.status == 401) {
        if (
            service !== "Auth" &&
            summary !== "CheckTokenPassword" &&
            summary !== "ResetPassword"
        ) {
            toastr.error(`Session expired!`, "Error!");
            localStorage.removeItem("AuthorizationPl");
            localStorage.removeItem("dataPl");
            //localStorage.removeItem("contrast");
            //localStorage.removeItem("reading");
            window.location.href = "#/login";
        } else throw error;
    } else if (
        response &&
        response.status === 500 &&
        service !== "Note" &&
        summary !== "Get2"
    ) {
        window.location.href = "#/server-error";
        throw error;
    } else throw error;
};

const getRequest = ({
    service,
    summary,
    method,
    url,
    parameters,
}: {
    service: string;
    summary: string;
    method: string;
    url: string;
    parameters: Array<object>;
}) => {
    return (data: object, config?: object) => {
        const parametersWithData = getParametersWithData(parameters, data);
        let bodyValues =
            parametersWithData &&
            parametersWithData
                .filter((parameter: any) => parameter.in == "body")
                .reduce((bodyValues, { name, value, type }: any) => {
                    if (name) bodyValues[name] = value;
                    else if (type === "json") return value;
                    return bodyValues;
                }, {});

        const serialize = parametersWithData
            .filter((parameter: any) => parameter.in == "body")
            .find(each => each.type == "serialize")

        //serialize is a no parent root unique json object (post with body and query parameters)
        if (serialize) {
            bodyValues = serialize.value
        }

        if (method.toLowerCase() === "delete")
            return Request[method.toLowerCase()](
                getURL(url, parametersWithData),
                { ...config, data: bodyValues }
            ).catch(processError({ service, summary }));
        else if (method.toLowerCase() === "get")
            return Request[method.toLowerCase()](
                getURL(url, parametersWithData),
                config
            ).catch(processError({ summary, method }));
        else
            return Request[method.toLowerCase()](
                getURL(url, parametersWithData),
                bodyValues,
                config
            ).catch(processError({ service, summary }));
    };
};

const LIST_ENDPOINT: Array<any> = Object.keys(_ENDPOINT).reduce(
    (acc, serviceName: string) => [
        ...acc,
        ..._ENDPOINT[serviceName].map((endpoint: any) => ({
            service: serviceName,
            ...endpoint,
        })),
    ],
    []
);

const reduceService = (
    services: any,
    {
        url,
        method,
        service,
        summary,
        parameters,
    }: {
        url: string;
        method: string;
        service: string;
        summary: string;
        parameters: Array<object>;
    }
) => {
    if (!services[service]) services[service] = {};

    services[service][summary] = getRequest({
        service,
        summary,
        method,
        url,
        parameters,
    });
    services[service][summary];
    return services;
};

export default LIST_ENDPOINT.reduce(reduceService, {});
